import { useEffect, useState } from "react";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";
import { Bookmark, BookmarkPlus, Pencil, X, Star } from "lucide-react";

const same = (f, cur) => f.q === cur.q && f.view === cur.view && f.status === cur.status && f.assignee === cur.assignee && f.sort === cur.sort;

export function SavedClientFilters({ current, onApply, userId }) {
  const [saved, setSaved] = useState([]);
  useEffect(() => { api.get("/me/client-filters").then((r) => setSaved(r.data || [])).catch(() => {}); }, []);
  const builtin = { id: "builtin-mine", name: "My active clients", q: "", view: "active", status: "", assignee: userId || "", sort: "desc", builtin: true };

  const persist = async (next, msg) => {
    try { const r = await api.put("/me/client-filters", next); setSaved(r.data); if (msg) toast.success(msg); }
    catch (e) { toast.error(apiErr(e)); }
  };
  const saveCurrent = () => {
    if (saved.length >= 20) { toast.error("You can keep up to 20 saved filters"); return; }
    const name = (window.prompt("Name this filter, e.g. \"Study permits – Gurleen\"") || "").trim();
    if (name) persist([...saved, { ...current, name }], "Filter saved");
  };
  const rename = (f) => {
    const name = (window.prompt("Rename filter", f.name) || "").trim();
    if (name && name !== f.name) persist(saved.map((x) => (x.id === f.id ? { ...x, name } : x)), "Filter renamed");
  };
  const remove = (f) => { if (window.confirm(`Delete saved filter "${f.name}"?`)) persist(saved.filter((x) => x.id !== f.id), "Filter deleted"); };

  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="saved-client-filters">
      <span className="text-xs font-semibold text-slate-400 inline-flex items-center gap-1 mr-1"><Bookmark className="h-3.5 w-3.5" /> Saved filters</span>
      {[builtin, ...saved].map((f) => {
        const on = same(f, current);
        return (
          <span key={f.id} className={`group inline-flex items-center rounded-full border text-xs font-semibold transition-colors ${on ? "bg-primary text-white border-primary" : "bg-white text-slate-600 border-slate-200 hover:border-slate-300"}`}>
            <button type="button" data-testid={`saved-filter-${f.id}`} onClick={() => onApply(f)} className="pl-3 pr-2 py-1 inline-flex items-center gap-1">
              {f.builtin && <Star className="h-3 w-3" />}{f.name}
            </button>
            {!f.builtin && (<>
              <button type="button" data-testid={`saved-filter-rename-${f.id}`} title="Rename" onClick={() => rename(f)} className={`pr-1 opacity-60 hover:opacity-100 ${on ? "text-white" : "text-slate-400"}`}><Pencil className="h-3 w-3" /></button>
              <button type="button" data-testid={`saved-filter-delete-${f.id}`} title="Delete" onClick={() => remove(f)} className={`pr-2 opacity-60 hover:opacity-100 ${on ? "text-white" : "text-slate-400"}`}><X className="h-3 w-3" /></button>
            </>)}
          </span>
        );
      })}
      <button type="button" data-testid="save-client-filter" onClick={saveCurrent} className="inline-flex items-center gap-1 px-3 py-1 rounded-full border border-dashed border-primary/40 text-xs font-semibold text-primary hover:bg-primary/5">
        <BookmarkPlus className="h-3.5 w-3.5" /> Save filters
      </button>
    </div>
  );
}
